/**
 * ANQ.ContentServiceManagement.API 
 * Content Service Mgt API
 *
 * OpenAPI spec version: v1
 * Contact: support@coure-tech.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface ServiceProviderContentsDto { 
    _id?: string;
    name?: string;
    description?: string;
    commandRecordId?: string;
    contentPrivacyTypeId?: number;
    isDeleted?: boolean;
    dateCreated?: Date;
    contentProviderName?: string;
    contentProviderId?: string;
    status?: number;
    contentEntityStatus?: string;
}